// extracted by mini-css-extract-plugin
export var label = "divider-module--label--91622";
export var root = "divider-module--root--5e486";